export const PRODUCT_REQUEST_PENDING = "PRODUCT_REQUEST_PENDING";
export const PRODUCT_REQUEST_FAILURE = "PRODUCT_REQUEST_FAILURE";
export const PRODUCT_REQUEST_SUCCESS = "PRODUCT_REQUEST_SUCCESS";
